/* src/app/FW/components/UI/menu/main-menu/main-menu.component.scss */
.mat-nav-list {
  padding-top: 0;
}
/*# sourceMappingURL=main-menu.component.css.map */
